module.exports = __webpack_public_path__ + "img/20200510.a971cec2.png";